import { render, staticRenderFns } from "./bootstrap4-template.vue?vue&type=template&id=060aaf3a"
import script from "./bootstrap4-template.vue?vue&type=script&lang=js"
export * from "./bootstrap4-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports